import { Activity, ClipboardCheck, Pill, Utensils, type LucideIcon } from "lucide-react";

/** Ícones dos tipos de atividade (`stay_activity_types.icon`). */
export const ACTIVITY_TYPE_ICONS: Record<string, LucideIcon> = {
  pill: Pill,
  utensils: Utensils,
  activity: Activity,
  "clipboard-check": ClipboardCheck,
};

export const activityTypeIcon = (icon: string | null | undefined): LucideIcon =>
  ACTIVITY_TYPE_ICONS[icon ?? "activity"] ?? Activity;

/** Cor de fallback quando o tipo não tem cor definida. */
export const ACTIVITY_TYPE_FALLBACK_COLOR = "#75716a";
